import React from 'react';
import {
    Card, CardContent, Grid, Typography
} from '@material-ui/core';


const DelinquencyLegend = props => {

    const { totalDelinquentForProperty, totalDelinquentForExictions } = props;


    return (
        <Card style={{ width: '400px' }}>
            <CardContent>
                <Grid container>

                    <Grid container item justifyContent='space-between'>
                        <Typography>
                            <strong>Total Owed</strong>
                        </Typography>
                        <Typography>
                            <strong>Amount</strong>
                        </Typography>
                    </Grid>

                    <Grid container item justifyContent='space-between'>
                        <Typography>Entire Property</Typography>
                        <Typography>
                            <strong>{totalDelinquentForProperty}</strong>
                        </Typography>
                    </Grid>


                    <Grid container item justifyContent='space-between'>
                        <Typography>Evictions Only</Typography>
                        <Typography>
                            <strong>{totalDelinquentForExictions}</strong>
                        </Typography>
                    </Grid>

                </Grid>

            </CardContent>
        </Card>
    );
};

export default DelinquencyLegend;

